export default __webpack_public_path__ + "images/cv-434373304db5970887de778fb452f3a0.svg";